import { createAction, props } from '@ngrx/store';
import { CaseState } from '../../interfaces/interfaces';

export const saveAdderssInformations = createAction(
  '[Case] Save Address Informations Case',
  props<{ caseObj: any }>()
);
export const saveAdderssInformationsSuccess = createAction(
  '[Case] Save Address Informations Case Success',
  props<{ data: any }>()
);
export const saveAdderssInformationsFailure = createAction(
  '[Case] Save Address Informations Case Failure',
  props<{ error: string }>()
);

export const setAddressInformationSuccess = (
  state: CaseState,
  { data }: { data: any }
) => {
  return {
    ...state,
    case: {
      ...state.case,
      addressInformations: {
        pickupInstitution: data?.addressInformations?.pickupInstitution?.id
          ? {
              label: data?.addressInformations?.pickupInstitution?.signboard,
              value: data?.addressInformations?.pickupInstitution?.id,
            }
          : null,
        dropoffInstitution: data?.addressInformations?.dropoffInstitution?.id
          ? {
              label: data?.addressInformations?.dropoffInstitution?.signboard,
              value: data?.addressInformations?.dropoffInstitution?.id,
            }
          : null,
        pickupAddress: data?.addressInformations?.pickupAddress ?? null,
        dropoffAddress: data?.addressInformations?.dropoffAddress ?? null,
        dropoffInstitutionApproval:
          data?.addressInformations?.dropoffInstitutionApproval,
        dropoffInstitutionDescription:
          data?.addressInformations?.dropoffInstitutionDescription,
      },
      id: data?.id,
      caseType: data?.caseType,
      caseNo: data?.caseNo,
      createdAt:data?.createdAt ?? null,
      uid:data?.uid ?? null,
      caseStatus: data?.caseStatus,
      appointmentStatus: data?.appointmentStatus,
      recordType:data?.recordType ?? null,
      appointmentStartDate:data?.appointmentStartDate ?? null,
      appointmentEndDate:data?.appointmentEndDate ?? null,
      appointmentDuration:data?.appointmentDuration ?? null,
      cancelReason:data?.cancelReason?.valueObject?.id?.value ?? null,
      cancelDescription:data?.cancelDescription ?? null,
      isCaseApproved:data?.isCaseApproved ?? null,
      caseDate: data?.caseDate,
      plannedVehicle:data?.plannedVehicle ?? null,
      plannedStaff:data?.plannedStaff ?? null,
      childAppointments: data?.childAppointments ?? state.case.childAppointments ?? [],
      parentAppointment: data?.parentAppointment ?? state.case.parentAppointment ?? null,
      parentAppointmentId: data?.parentAppointmentId ?? state.case.parentAppointmentId ?? null,
    },
    loading: false,
    error: null,
  };
};
